const currencyNameBySymbol: Record<string, string> = {
  UTK: 'xMoney Token',
  BNB: 'Binance Coin',
  BUSD: 'Binance USD',
  USDT: 'Tether USD',
  BTC: 'Bitcoin',
  ETH: 'Ethereum',
  AVAX: 'Avalanche',
  USDC: 'USD Coin',
  SOL: 'Solana',
  EGLD: 'MultiversX',
  RIDE: 'Holoride',
  DASH: 'Dash',
  POL: 'Polygon',
  SUI: 'Sui',
};

export default currencyNameBySymbol;
